// Copyright 2026 Zibby Lab. Apache-2.0.
//
// PillButton — the shared header-action pill. It is EXACTLY the pipeline
// "Trigger" button (IonButton + `btn-white header-action-btn`), wrapped once
// so the app detail "Start" can reuse the identical thing. Nothing fancy on
// purpose.
//
// `loading` adds the standard loading-button pattern WITHOUT a width jump:
// the label keeps rendering (so the button width never changes) but is hidden
// via visibility, and a small spinner is overlaid dead-center on top of it.

import React from 'react';
import PropTypes from 'prop-types';
import { IonButton } from '@ionic/react';

export default function PillButton({
  children,
  onClick,
  disabled = false,
  loading = false,
  title,
  className,
  type = 'button',
}) {
  return (
    <IonButton
      type={type}
      className={`btn-white header-action-btn${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
    >
      {loading ? (
        <span className="pill-button-loading">
          {/* Label still reserves the FULL box (visibility:hidden, not
              display:none) so idle ↔ loading occupy the SAME width AND height.
              The spinner is a pure-CSS element (NOT IonSpinner) positioned
              absolutely on top — Ionic doesn't reliably forward className to
              ion-spinner's shadow host, so an IonSpinner here stayed in-flow at
              its 28px default and grew the button. A plain span can't. */}
          <span className="pill-button-loading-label" aria-hidden="true">
            {children}
          </span>
          <span className="pill-button-loading-spinner" aria-hidden="true" />
        </span>
      ) : (
        children
      )}
    </IonButton>
  );
}

PillButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};
